import React, { useState } from 'react'
import './Contactus.css'
import { FaFacebookF, FaInstagram, FaLinkedinIn } from 'react-icons/fa'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

function Contactus() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    business: '',
    message: ''
  });
  
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [id]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await fetch('https://b.centrexmarineservices.com/Api/Sendmail.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      const data = await response.json();
      
      if (data.status === 'success') {
        toast.success(data.message || "Message sent successfully!");
        setFormData({
          name: '',
          email: '',
          phone: '',
          business: '',
          message: ''
        });
      } else {
        toast.error(data.message || "Something went wrong. Please try again.");
      }
    } catch (error) {
      toast.error("Network error. Please check your connection and try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="main-contactus-container">
      <ToastContainer position="top-right" autoClose={5000} />

      {/* Map section at the top */}
      <div className="contactus-map">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d108393.35303845392!2d74.4689356!3d32.4945887!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391eea5674db6cfd%3A0xa8d03983946d4744!2sSialkot%2C%20Punjab%2C%20Pakistan!5e0!3m2!1sen!2s!4v1652345678901!5m2!1sen!2s"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Centrex marine services Location"
        ></iframe>
      </div>

      {/* White gap */}
      <div className="white-gap"></div>

      {/* Contact content section */}
      <div className="contactus-content">
        {/* Left side - Contact form */}
        <div className="contactus-form-section">
          <h2>Get In Touch</h2>
          <p>To get in touch with Centrex marine services Agencies, please call or email us. For site specific contact details please use the form below.</p>
          
          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name">Name <span className="required">*</span></label>
              <input 
                type="text" 
                id="name" 
                className="form-control" 
                required 
                value={formData.name}
                onChange={handleChange}
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="email">Email <span className="required">*</span></label>
              <input 
                type="email" 
                id="email" 
                className="form-control" 
                required 
                value={formData.email}
                onChange={handleChange}
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="phone">Phone Number <span className="required">*</span></label>
              <input 
                type="tel" 
                id="phone" 
                className="form-control" 
                required 
                value={formData.phone}
                onChange={handleChange}
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="business">Business You Are Interested In <span className="required">*</span></label>
              <input 
                type="text" 
                id="business" 
                className="form-control" 
                required 
                value={formData.business}
                onChange={handleChange}
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="message">Message <span className="required">*</span></label>
              <textarea 
                id="message" 
                className="form-control" 
                rows="5" 
                required
                value={formData.message}
                onChange={handleChange}
              ></textarea>
            </div>
            
            <button 
              type="submit" 
              className="submit-btn" 
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Sending...' : 'Submit'}
            </button>
          </form>
        </div>
        
        {/* Vertical divider */}
        <div className="vertical-divider"></div>
        
        {/* Right side - Contact info */}
        <div className="contactus-info-section">
          <div className="social-section" id="sticky-social">
            <h3>SOCIAL LINKS</h3>
            <div className="social-icons">
              <a href="https://www.facebook.com/share/1FGkRgLeQp/" target="_blank" rel="noopener noreferrer" className="social-icon">
                <FaFacebookF />
              </a>
              <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer" className="social-icon">
                <FaInstagram />
              </a>
              <a href="https://www.linkedin.com/in/centrex-marine-services-3a979b360?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app" target="_blank" rel="noopener noreferrer" className="social-icon">
                <FaLinkedinIn />
              </a>
            </div>
          </div>
          
          <div className="inquiries-section">
            <h3>GENERAL INQUIRIES</h3>
            <p>11-A, NOOR VILLAS, NEAR SAFARI HALLS,KASHMIR ROAD, SIALKOT – PAKISTAN</p>
          </div>
          
          <div className="email-section">
            <h3>EMAIL</h3>
            <a href="mailto:info@centrexmarineservices.com" className="email-link">info@centrexmarineservices.com</a>
          </div> 

          <div>
            <div>
              <img className='logo-contact' src='./Logo/logob.png'/>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Contactus
